/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract the original value from the new value, divide by the original value, then multiply by 100.`)
};

const es_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resta el valor original del valor nuevo, divide entre el valor original y multiplica por 100.`)
};

const de_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe den Ausgangswert vom neuen Wert ab, teile das Ergebnis durch den Ausgangswert und multipliziere mit 100.`)
};

const nl_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trek de oorspronkelijke waarde af van de nieuwe waarde, deel door de oorspronkelijke waarde en vermenigvuldig met 100.`)
};

const fr_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustrayez la valeur d'origine de la nouvelle valeur, divisez par la valeur d'origine, puis multipliez par 100.`)
};

const it_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai il valore originale dal nuovo valore, dividi per il valore originale, poi moltiplica per 100.`)
};

const pt_br2_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o valor original do novo valor, divida pelo valor original e depois multiplique por 100.`)
};

const pt_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o valor original do novo valor, divida pelo valor original e depois multiplique por 100.`)
};

const ja_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい値から元の値を引き、元の値で割ってから100を掛けます。`)
};

const zh_pct_increase_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用新值减去原始值，除以原始值，再乘以 100。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq1_a", locale)
	if (locale === "en") return en_pct_increase_faq1_a(inputs)
	if (locale === "es") return es_pct_increase_faq1_a(inputs)
	if (locale === "de") return de_pct_increase_faq1_a(inputs)
	if (locale === "nl") return nl_pct_increase_faq1_a(inputs)
	if (locale === "fr") return fr_pct_increase_faq1_a(inputs)
	if (locale === "it") return it_pct_increase_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq1_a(inputs)
	if (locale === "pt") return pt_pct_increase_faq1_a(inputs)
	if (locale === "ja") return ja_pct_increase_faq1_a(inputs)
	return zh_pct_increase_faq1_a(inputs)
};